export default __webpack_public_path__ + "static/media/section1.20446771.jpg";